export class ProjectDataSatelite {
    public lat: number = 41.75786995;
    public lng: number = 2.03118204;
    public zoom: number = 9;
}